import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { HealthcareProvider } from '@chiroup/core/types/HealthcareProvider.type';
import { useQuery } from 'react-query';

// Ported from healthcom-app. The `/healthcare-providers` endpoint
// lives on the schedule backend and derives the clinic from the
// active session (request | patient | kiosk), so we route through
// `api` (authed schedule API) — Amplify forwards whichever session
// token is available.
//
// `scopeKey` is just a cache-scoping hint (typically `requestId` for
// the direct-request flow, the clinic path for the portal). Defaults
// to `'session'` for callers that don't have one. The server never
// reads it.

const useHealthcareProvidersAll = (scopeKey?: string) => {
  const { data, isFetching, refetch } = useQuery<HealthcareProvider[]>(
    ['healthcareProviders', scopeKey || 'session'],
    () => ChiroUpAPI.get('api', `/healthcare-providers`, {}),
    { refetchOnWindowFocus: false }
  );

  return { data, isFetching, refetch };
};

export default useHealthcareProvidersAll;
